import { scratchEventType } from "./type";

const initialAuthState = {
  scratchEvents: null,
  userScratchEventsHistory: null,
  scratchEventDropdownList: [],
  scratchEvent: null,
  isLoading: false,
  statusCode: null,
  activeTab: 0
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case scratchEventType.GET_SCRATCH_EVENT_REQUEST:
      return { ...state, isLoading: true };
    case scratchEventType.GET_SCRATCH_EVENT_SUCCESS:
      return { ...state, isLoading: false, scratchEvents: action.payload.data };
    case scratchEventType.GET_SCRATCH_EVENT_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case scratchEventType.GET_USER_SCRATCH_EVENT_LIST_REQUEST:
      return { ...state, isLoading: true };
    case scratchEventType.GET_USER_SCRATCH_EVENT_LIST_SUCCESS:
      return { ...state, isLoading: false, userScratchEventsHistory: action.payload.data };
    case scratchEventType.GET_USER_SCRATCH_EVENT_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case scratchEventType.GET_SCRATCH_EVENT_DROPDOWN_REQUEST:
      return { ...state, isLoading: true };
    case scratchEventType.GET_SCRATCH_EVENT_DROPDOWN_SUCCESS:
      return { ...state, isLoading: false, scratchEventDropdownList: action.payload.data };
    case scratchEventType.GET_SCRATCH_EVENT_DROPDOWN_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case scratchEventType.GET_SINGLE_PROMO_CODE_REQUEST:
      return { ...state, isLoading: true, statusCode: null };
    case scratchEventType.GET_SINGLE_PROMO_CODE_SUCCESS:
      return { ...state, isLoading: false, scratchEvent: action.payload };
    case scratchEventType.GET_SINGLE_PROMO_CODE_FAIL:
      return { ...state, isLoading: false, error: action.error, statusCode: action.statusCode };
    case scratchEventType.CHANGE_CUSTOMER_TAB:
      return { ...state, activeTab: action.payload };
    default:
      return state;
  }
};
